<template>
<div class="container">
  <div class="row mb-2">
    <div class="col-auto ms-auto" v-if="mode === 'update' && formDisabled">
      <a href="#" @click="onPwReset" v-b-tooltip.hover title="Reset Password" class="me-3"><i class="fas fa-key"></i></a>
      <a href="#" @click="formDisabled = false" v-b-tooltip.hover title="Edit"><i class="fas fa-edit"></i></a>
    </div>
  </div>
  
  <form>
  <fieldset :disabled="formDisabled">
    <div class="row mb-2">
      <div v-if="mode !== 'add'" class="fw-bold">{{axu.userId}}</div>
      <input-text v-else v-model="axu.userId" label="User ID"></input-text>
    </div>
    <div class="row mb-2">
      <input-text v-model="axu.firstName" label="First Name"></input-text>
      <input-text v-model="axu.lastName" label="Last Name"></input-text>
    </div>
    <div class="row mb-4">
      <input-text v-model="axu.emailAddress" label="Email Address"></input-text>
    </div>
    <div class="row mb-2 bg-yellow px-2 py-2 border">
      <div class="row">
        <div class="col-auto fw-bold fst-italic small">Permissions</div>
        <div v-if="!formDisabled" class="col-auto ms-auto"><a href="#" @click.prevent="onPermSelect" v-b-tooltip.hover title="Add Permission"><i class="fas fa-plus-square"></i></a></div>
      </div>
      <div v-for="(perm,idx) in axu.userPermissions" :key="idx" class="col-auto badge bg-info mx-2 my-2">
        {{perm}}<a v-if="!formDisabled" href="#" @click.prevent="removePerm(idx)"><i class="fa fa-times text-danger ms-2"></i></a>
      </div>
    </div>
  </fieldset>
  </form>
  
  <div class="row mt-4">
    <div class="col-auto ms-auto" v-if="!formDisabled">
      <button class="btn btn-secondary me-2" @click="onCancel()">Cancel</button>
      <button class="btn btn-primary" @click="onSave()">Save</button>
    </div>
  </div>
  
  <b-modal id="perm-select" title="Add Permission" hide-footer>
    <div class="row">
      <input-select v-model="permToAdd" group-class="col">
        <option v-for="perm in permList.filter(permListFilter)" :key="perm">{{perm}}</option>
      </input-select>
    </div>
  </b-modal>
  
</div>
</template>

<script>
import HelpersMixin from '../utils/HelpersMixin.js'
export default {
  name: 'AdminUserForm',
  mixins: [HelpersMixin],
  props: {
    userId: String
  },
  data () {
    return {
      axu: { userPermissions: [] },
      mode: 'add',
      formDisabled: true,
      permToAdd: null,
      permSelectUnwatch: null,
      permList: []
    }
  },
  mounted () {
    this.getPermList()
    if (this.userId) {
      this.getAxUser()
      this.mode = 'update'
    } else {
      this.mode = 'add'
      this.formDisabled = false
    }
  },
  methods: {
    getAxUser: function () {
      this.axios.get('/ax/adminuser/' + this.userId)
      .then(response => {
        this.axu =  response.data
      })
      .catch(error => this.handleError(error))
    },
    onPwReset: function () {
      this.$bvModal.msgBoxConfirm("Are you sure you want to reset this user's password?", {
          title: 'Please Confirm',
          size: 'sm',
          buttonSize: 'sm',
          centered: true
        })
        .then(value => {
          console.log('confirm value: ' + value)
          if (value) {
            this.submitPwReset()
          }
        })
    },
    submitPwReset: function () {
      console.log('submitting pw reset')
      this.axios.post('/ax/adminuser/resetloginpass/' + this.userId)
      .then(() => {
        this.$toasted.success('A new password has been generated and sent to ' + this.axu.emailAddress)
        this.$emit('saved')
      })
      .catch(error => {
        this.handleError(error)
        this.formDisabled = false
      })
    },
    onCancel: function () {
      this.$emit('cancelled')
    },
    onSave: function () {
      var endpoint = ''
      if (this.mode === 'add') {
        endpoint = '/ax/adminuser/create'
      } else {
        endpoint = '/ax/adminuser/update'
      }
      this.axios.post(endpoint, this.axu)
      .then(response => {
        this.formDisabled = true
        this.axu = response.data
        if (this.mode === 'add') {
          this.$toasted.success('User ' + this.axu.userId + ' created. A temporary password has been generated and sent to ' + this.axu.emailAddress)
        } else {
          this.$toasted.success('User ' + this.axu.userId + ' updated')
        }
        this.$emit('saved')
      })
      .catch(error => {
        this.handleError(error)
        this.formDisabled = false
      })
    },
    getPermList: function () {
      this.axios.get('/ax/permissions')
      .then(response => {
        this.permList = response.data
      })
      .catch(error => this.handleError(error))
    },
    permListFilter: function (perm) {
      if (this.axu.userPermissions && this.axu.userPermissions.includes(perm)) {
        return false
      }
      return true
    },
    onPermSelect: function () {
        this.permToAdd = null
        this.permSelectUnwatch = this.$watch('permToAdd', this.addPerm)
        this.$bvModal.show('perm-select')
    },
    addPerm: function () {
      if (this.permToAdd) {
        if (!this.axu.userPermissions) {
            this.axu.userPermissions = []
        }
        this.axu.userPermissions.push(this.permToAdd)
      }
      this.$bvModal.hide('perm-select')
      this.permSelectUnwatch()
    },
    removePerm: function (idx) {
      this.axu.userPermissions.splice(idx, 1)
    }
  }
}
</script>
<style scoped>
.bg-yellow { background-color: #FFFDD0; }
</style>
